import React, { useEffect } from "react";
import { SignIn } from "@clerk/clerk-react";
import logo from "../assets/images/png/WPC-logo-white.png";
import { Helmet } from "react-helmet-async";
const SignInPage = () => {
  return (
    <div>
      <Helmet>
        <title>Sign In | Work Permit Consultancy</title>
        <meta
          name="description"
          content="Sign in to your Work Permit Consultancy account to manage your work permit application, track progress, and connect with our immigration experts."
        />
        <meta name="robots" content="noindex, nofollow" />{" "}
        {/* ← important for login pages */}
        {/* Open Graph / Social sharing */}
        <meta property="og:title" content="Sign In - Work Permit Consultancy" />
        <meta
          property="og:description"
          content="Access your account to continue your work permit journey with expert support."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.workpermitconsultancy.com/sign-in"
        />
        {/* Prevent search engines from indexing login pages */}
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>
      <div className="SignIn flex items-center justify-center md:h-screen bg-cover bg-center relative">
        {/* Darken overlay */}
        <div className="absolute inset-0 bg-black opacity-30"></div>

        {/* Centered container */}
        <div className="relative flex  flex-wrap items-center justify-center z-10 my-[10%] rounded-lg max-w-[90%] md:h-[95%] w-full text-center ">
          {/* First Div */}
          <div className="LoginFirstDiv w-full h-1/2 md:w-1/2 md:h-full p-4 md:mb-0 flex flex-col justify-center items-center">
            <div className="w-[80%] m-[10%] lg:w-[60%]">
              <img
                src={logo}
                alt="Work Permit Consultancy"
                className="w-48 md:w-[21rem] mb-2 mx-auto"
              />
              <p className="text-[#dcdcdc] font-Poppins text-balance">
                Your trusted partner for obtaining work permits, specialize in
                simplifying the application process and providing expert
                consultancy services
              </p>
            </div>
          </div>

          {/* Second Div */}
          <div className="w-full h-1/2 md:w-1/2 md:h-full flex flex-col justify-center items-center bg-[#f4f7ff]">
            <div className="w-[95%]">
              <SignIn signUpUrl="/sign-up" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
